import { Outlet } from 'react-router';

/**
 * FO 공개 콘텐츠 컨테이너 — 워크스페이스와 라우트를 공유하는 화면(기업 인증 안내 등)을
 * 공개 레이아웃에서 열 때 본문 폭·좌우 여백을 준다(워크스페이스에서는 WorkspaceBody 가 담당).
 * 자체 컨테이너를 가진 공개 화면(둘러보기·올해 꼭 보는 사업·법무)은 이 래퍼를 거치지 않는다.
 */
export function FoContentContainer() {
  return (
    <div className="mx-auto w-full max-w-content px-4 py-10 sm:px-gutter">
      <Outlet />
    </div>
  );
}
